// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-e2mdyo {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 201;
}

.css-1cychdt {
  display: flex;
  box-sizing: border-box;
  height: 56px;
  padding-right: 12px;
  padding-left: 12px;
  position: relative;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.css-1cychdt::after {
  height: 4px;
  position: absolute;
  top: 100%;
  right: 0px;
  left: 0px;
  background: linear-gradient(rgba(9, 30, 66, 0.13) 0px, rgba(9, 30, 66, 0.13) 1px, rgba(9, 30, 66, 0.08) 1px, rgba(9, 30, 66, 0) 4px);
  content: "";
}

.css-vtikxo {
  display: flex;
  min-width: 0px;
  height: inherit;
  align-items: center;
  flex-grow: 1;
}

.css-1rowtot {
  display: flex;
  align-items: center;
  margin-left: 0px;
}

.css-b7sh1q, .css-b7sh1q:hover, .css-b7sh1q:active, .css-b7sh1q:focus, .css-b7sh1q:visited, .css-b7sh1q:disabled, .css-b7sh1q[disabled] {
  align-items: baseline;
  border-width: 0;
  border-radius: 100%;
  box-sizing: border-box;
  display: flex;
  font-size: inherit;
  font-style: normal;
  font-family: inherit;
  font-weight: 500;
  max-width: 100%;
  position: relative;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
  white-space: nowrap;
  background: var(--ds-background-brand-bold, #0052CC);
  color: var(--ds-text-subtle, #344563);
  cursor: pointer;
  height: auto;
  line-height: 2.2857142857em;
  padding: 4px;
  vertical-align: middle;
  width: auto;
  justify-content: center;
  outline: none;
  margin: 0 2px;
  background-color: transparent;
}

.css-b7sh1q > span, .css-b7sh1q:hover > span, .css-b7sh1q:active > span, .css-b7sh1q:focus > span, .css-b7sh1q:visited > span, .css-b7sh1q:disabled > span, .css-b7sh1q[disabled] > span {
  margin: 0px;
}

.css-16j5qb5 {
  opacity: 1;
  transition: opacity 0.3s ease 0s;
  display: flex;
  margin: 0px 2px;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: center;
  font-size: 0px;
  line-height: 0;
  -webkit-user-select: none;
          user-select: none;
}

.css-snhnyn {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
}

.css-snhnyn > svg {
  overflow: hidden;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  color: var(--icon-primary-color);
  fill: var(--icon-secondary-color);
  vertical-align: bottom;
}

.logo-container img {
  width: 130px;
  display: flex;
  padding: 4px;
  align-items: center;
  background: none;
  border: 0px;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  margin-left: -4px;
}

.css-1qtw0hy:first-of-type {
  margin-left: 0px;
}

@media (min-width: 1280px) {
  .css-1qtw0hy {
    margin: 0px 16px;
  }
}
.css-1qtw0hy {
  display: flex;
  padding: 4px;
  align-items: center;
  background: none;
  border: 0px;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
}

.css-vtikxo > * {
  flex-shrink: 0;
}

.css-6wmz0q {
  max-height: 28px;
  display: flex;
  max-width: var(--logo-max-width);
}

.css-6wmz0q > * {
  max-height: 24px;
}

.css-12mte9y {
  display: inline-block;
  position: relative;
  color: var(--logo-color);
  fill: var(--logo-fill);
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  white-space: normal;
  height: 32px;
}

.css-12mte9y > svg {
  height: 100%;
  fill: inherit;
}

.css-4mgr5f, .css-4mgr5f:hover, .css-4mgr5f:active, .css-4mgr5f:focus, .css-4mgr5f:visited, .css-4mgr5f:disabled, .css-4mgr5f[disabled] {
  align-items: baseline;
  border-width: 0;
  border-radius: 3px;
  box-sizing: border-box;
  display: inline-flex;
  font-size: inherit;
  font-style: normal;
  font-family: inherit;
  font-weight: 500;
  max-width: 100%;
  position: relative;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
  white-space: nowrap;
  background: var(--ds-background-brand-bold, #0052CC);
  color: var(--ds-text-subtle, #344563);
  cursor: pointer;
  height: 2.2857142857em;
  line-height: 2.2857142857em;
  padding: 0 4px;
  vertical-align: middle;
  width: auto;
  justify-content: center;
  outline: none;
  background-color: transparent;
  margin-left: 0;
  margin-right: 0;
}

.css-178ag6o {
  opacity: 1;
  transition: opacity 0.3s ease 0s;
  margin: 0px 2px;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-uiquy5 > * {
  margin: 0px 4px;
  flex-shrink: 0;
}

.css-1rowtot {
  display: flex;
  align-items: center;
  margin-left: 0px;
}

.css-le7mka {
  display: flex;
  height: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.css-1ozpmrm {
  width: 100%;
  min-width: 1px;
  margin: 0px;
  position: relative;
  flex-shrink: 1;
}

.css-d4blq8 {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.css-9wcsid {
  position: relative;
  width: 32px;
  height: 32px;
}

@media screen and (min-width: 781px) {
  .css-9wcsid {
    min-width: 200px;
  }
}
.css-d4blq8 > * {
  margin-right: 4px;
  flex-shrink: 0;
}

.css-79elbk {
  position: relative;
}

.css-44vo0a {
  position: relative;
  width: 780px;
  box-shadow: var(--ds-shadow-overlay, 0 4px 8px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31));
  border-radius: 3px;
  background-color: var(--ds-surface-overlay, #fff);
  overflow: hidden;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.css-9s05y4 {
  display: block;
  width: 8px;
  height: 8px;
  background-color: rgb(153, 141, 217);
  position: absolute;
  top: 0px;
  left: 24px;
  border-radius: 8px;
  border: 3px solid white;
}

.css-1kr2iex {
  height: 24px;
  width: 24px;
  align-items: stretch;
  background-color: var(--ds-surface-overlay, #FFFFFF);
  border-radius: 50%;
  box-sizing: content-box;
  cursor: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;
  overflow: hidden;
  position: static;
  transform: translateZ(0px);
  transition: transform 200ms ease 0s, opacity 200ms ease 0s;
  box-shadow: 0 0 0 2px var(--ds-surface-overlay, #FFFFFF);
  border: none;
  margin: 2px;
  padding: var(--ds-scale-0, 0px);
  font-size: inherit;
  font-family: inherit;
}

.css-13ep12v {
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1 1 100%;
}

.css-uiquy5 {
  display: flex;
  height: 100%;
  position: relative;
  align-items: stretch;
  flex: 1 0 0px;
  -webkit-box-flex: 1;
}

.css-8u8t57 {
  display: flex;
  height: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.css-8u8t57::after {
  height: 3px;
  position: absolute;
  right: 4px;
  bottom: 0px;
  left: 4px;
  background-color: var(--button-selected-border-color);
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
  content: "";
}

.css-pddbfj {
  position: relative;
  max-width: 100%;
  width: 200px;
}

.css-pddbfj {
  position: relative;
  max-width: 100%;
  width: 200px;
}

.css-wsgzdc {
  display: none;
}

.css-54uz93, .css-54uz93:hover, .css-54uz93:active, .css-54uz93:focus, .css-54uz93:visited, .css-54uz93:disabled, .css-54uz93[disabled] {
  align-items: baseline;
  border-width: 0;
  border-radius: 100%;
  box-sizing: border-box;
  display: flex;
  font-size: inherit;
  font-style: normal;
  font-family: inherit;
  font-weight: 500;
  max-width: 100%;
  position: relative;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
  white-space: nowrap;
  background: var(--ds-background-brand-bold, #0052CC);
  color: var(--ds-text-subtlest, #6B778C);
  cursor: pointer;
  height: auto;
  line-height: 2.2857142857em;
  padding: 4px;
  vertical-align: middle;
  width: auto;
  justify-content: center;
  outline: none;
  margin: 0 2px;
  background-color: var(--ds-background-input, #FFFFFF);
  border-color: var(--ds-border-input, #DFE1E6);
  icon-color: var(--ds-icon-subtle, #344563);
}

.css-1afrefi {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
  width: 24px;
  height: 24px;
}

.css-1afrefi > svg {
  overflow: hidden;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  color: var(--icon-primary-color);
  fill: var(--icon-secondary-color);
  vertical-align: bottom;
}

.css-lvi2ji {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 8px;
  left: 8px;
  color: var(--ds-text-subtlest, #6B778C);
}

.css-lvi2ji > span[role=img] {
  line-height: 0;
}

.css-1wits42 {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
  width: 16px;
  height: 16px;
}

.css-1wits42 > svg {
  overflow: hidden;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  color: var(--icon-primary-color);
  fill: var(--icon-secondary-color);
  vertical-align: bottom;
}

.css-1n34ig8 {
  height: 32px;
  width: 100%;
  padding: 0px 12px 0px 30px;
  box-sizing: border-box;
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  line-height: 20px;
  border: 2px solid var(--ds-border-input, #DFE1E6);
  box-shadow: none;
  background-color: var(--ds-background-input, #FFFFFF);
  color: var(--ds-text-subtlest, #6B778C);
}

@media (min-width: 1280px) {
  .css-15lsza2 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/header/header.component.scss"],"names":[],"mappings":"AA+BA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA9BJ;;AAgCA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,8BAAA;EACA,cAAA;AA7BJ;;AA+BA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,oIAAA;EACA,WAAA;AA5BJ;;AA8BA;EACI,aAAA;EACA,cAAA;EACA,eAAA;EAEA,mBAAA;EAEA,YAAA;AA3BJ;;AA6BA;EACI,aAAA;EAEA,mBAAA;EACA,gBAAA;AA1BJ;;AA4BA;EAII,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EAEA,2FAAA;EACA,mBAAA;EACA,oDAAA;EACA,qCAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EAIA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;AAzBJ;;AA2BA;EACI,WAAA;AAxBJ;;AA0BA;EACI,UAAA;EACA,gCAAA;EACA,aAAA;EACA,eAAA;EAEA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AAvBJ;;AAyBA;EACI,qBAAA;EACA,cAAA;EACA,cAAA;AAtBJ;;AAwBA;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;AArBJ;;AAuBA;EACI,YAAA;EACA,aAAA;EACA,YAAA;EAEA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AApBJ;;AAuBA;EACI,gBAAA;AApBJ;;AAsBA;EAEI;IACI,gBAAA;EApBN;AACF;AAsBA;EACI,aAAA;EACA,YAAA;EAEA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AApBJ;;AAuBA;EACI,cAAA;AApBJ;;AAsBA;EACI,gBAAA;EACA,aAAA;EACA,gCAAA;AAnBJ;;AAqBA;EACI,gBAAA;AAlBJ;;AAoBA;EACI,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,YAAA;AAjBJ;;AAmBA;EACI,YAAA;EACA,aAAA;AAhBJ;;AAkBA;EAII,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EAEA,2FAAA;EACA,mBAAA;EACA,oDAAA;EACA,qCAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EAIA,uBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAfJ;;AAiBA;EACI,UAAA;EACA,gCAAA;EACA,eAAA;EAEA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAdJ;;AAgBA;EACI,eAAA;EACA,cAAA;AAbJ;;AAeA;EACI,aAAA;EAEA,mBAAA;EACA,gBAAA;AAZJ;;AAcA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,sBAAA;AAXJ;;AAaA;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAVJ;;AAYA;EACI,aAAA;EAEA,mBAAA;EACA,cAAA;AATJ;;AAWA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AARJ;;AAUA;EACI;IACI,gBAAA;EAPN;AACF;AASA;EACI,iBAAA;EACA,cAAA;AAPJ;;AASA;EACI,kBAAA;AANJ;;AAQA;EACI,kBAAA;EACA,YAAA;EACA,oGAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AALJ;;AAOA;EACI,cAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;AAJJ;;AAMA;EACI,YAAA;EACA,WAAA;EAEA,oBAAA;EACA,oDAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EAEA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0DAAA;EACA,wDAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;AAHJ;;AAKA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAFJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;AADJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,sBAAA;AAAJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,qDAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;AACJ;;AACA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EAII,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EAEA,2FAAA;EACA,mBAAA;EACA,oDAAA;EACA,uCAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EAIA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,qDAAA;EACA,6CAAA;EACA,0CAAA;AAKJ;;AAHA;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;AAOJ;;AALA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;AAQJ;;AANA;EACI,cAAA;AASJ;;AAPA;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAUJ;;AARA;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;AAWJ;;AATA;EACI,YAAA;EACA,WAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,gBAAA;EACA,qDAAA;EACA,uCAAA;AAYJ;;AAVA;EACI;IACI,aAAA;EAaN;AACF","sourcesContent":[".header {\n    // display: flex;\n    // flex-direction: row;\n    // //height: 80px;\n    // align-items: center;\n    // //border-bottom: 1px solid lightgray;\n    // width: 100%;\n    // //color: #F8F8F8;\n    // //background-color: rgba(28,129,158,0.8);\n    // //color: white;\n    // // box-shadow: \n    // //     3px 3px 5px -1px rgb(0 0 0 / 20%), \n    // //     3px 6px 10px 0 rgb(0 0 0 / 14%), \n    // //     3px 1px 18px 0 rgb(0 0 0 / 12%);\n    // // color: rgba(28, 129, 158, 0.8);\n    // color: rgba(52, 69, 99, 1);\n    // background-color: rgba(0, 0, 0, 0);\n    // // box-shadow: \n    // //     3px 3px 5px -1px rgb(0 0 0 / 20%),\n    // //     3px 3px 5px -1px rgb(0 0 0 / 20%);;\n\n    // .header-item {\n    //     margin: 5px 15px;\n    // }\n}\n\n// .logo-container {\n//     img {\n//         width: 10em;\n//     }\n// }\n.css-e2mdyo {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    z-index: 201;\n}\n.css-1cychdt {\n    display: flex;\n    box-sizing: border-box;\n    height: 56px;\n    padding-right: 12px;\n    padding-left: 12px;\n    position: relative;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    flex-shrink: 0;\n}\n.css-1cychdt::after {\n    height: 4px;\n    position: absolute;\n    top: 100%;\n    right: 0px;\n    left: 0px;\n    background: linear-gradient(rgba(9, 30, 66, 0.13) 0px, rgba(9, 30, 66, 0.13) 1px, rgba(9, 30, 66, 0.08) 1px, rgba(9, 30, 66, 0) 4px);\n    content: \"\";\n}\n.css-vtikxo {\n    display: flex;\n    min-width: 0px;\n    height: inherit;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-flex: 1;\n    flex-grow: 1;\n}\n.css-1rowtot {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    margin-left: 0px;\n}\n.css-b7sh1q, .css-b7sh1q:hover, .css-b7sh1q:active, .css-b7sh1q:focus, .css-b7sh1q:visited, .css-b7sh1q:disabled, .css-b7sh1q[disabled] {\n    -webkit-align-items: baseline;\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    border-width: 0;\n    border-radius: 100%;\n    box-sizing: border-box;\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-family: inherit;\n    font-weight: 500;\n    max-width: 100%;\n    position: relative;\n    text-align: center;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    -webkit-transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n    transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n    white-space: nowrap;\n    background: var(--ds-background-brand-bold, #0052CC);\n    color: var(--ds-text-subtle, #344563);\n    cursor: pointer;\n    height: auto;\n    line-height: 2.2857142857142856em;\n    padding: 4px;\n    vertical-align: middle;\n    width: auto;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    outline: none;\n    margin: 0 2px;\n    background-color: transparent;\n}\n.css-b7sh1q > span, .css-b7sh1q:hover > span, .css-b7sh1q:active > span, .css-b7sh1q:focus > span, .css-b7sh1q:visited > span, .css-b7sh1q:disabled > span, .css-b7sh1q[disabled] > span {\n    margin: 0px;\n}\n.css-16j5qb5 {\n    opacity: 1;\n    transition: opacity 0.3s ease 0s;\n    display: flex;\n    margin: 0px 2px;\n    -webkit-box-flex: 0;\n    flex-grow: 0;\n    flex-shrink: 0;\n    align-self: center;\n    font-size: 0px;\n    line-height: 0;\n    user-select: none;\n}\n.css-snhnyn {\n    display: inline-block;\n    flex-shrink: 0;\n    line-height: 1;\n}\n.css-snhnyn > svg {\n    overflow: hidden;\n    pointer-events: none;\n    max-width: 100%;\n    max-height: 100%;\n    color: var(--icon-primary-color);\n    fill: var(--icon-secondary-color);\n    vertical-align: bottom;\n}\n.logo-container img {\n    width: 130px;\n    display: flex;\n    padding: 4px;\n    -webkit-box-align: center;\n    align-items: center;\n    background: none;\n    border: 0px;\n    border-radius: 3px;\n    color: inherit;\n    cursor: pointer;\n    margin-left: -4px;\n}\n// This is the bitbucket logo and name on the header\n.css-1qtw0hy:first-of-type {\n    margin-left: 0px;\n}\n@media (min-width: 1280px)\n{\n    .css-1qtw0hy {\n        margin: 0px 16px;\n    }\n}\n.css-1qtw0hy {\n    display: flex;\n    padding: 4px;\n    -webkit-box-align: center;\n    align-items: center;\n    background: none;\n    border: 0px;\n    border-radius: 3px;\n    color: inherit;\n    cursor: pointer;\n}\n//\n.css-vtikxo > * {\n    flex-shrink: 0;\n}\n.css-6wmz0q {\n    max-height: 28px;\n    display: flex;\n    max-width: var(--logo-max-width);\n}\n.css-6wmz0q > * {\n    max-height: 24px;\n}\n.css-12mte9y {\n    display: inline-block;\n    position: relative;\n    color: var(--logo-color);\n    fill: var(--logo-fill);\n    line-height: 1;\n    user-select: none;\n    white-space: normal;\n    height: 32px;\n}\n.css-12mte9y > svg {\n    height: 100%;\n    fill: inherit;\n}\n.css-4mgr5f, .css-4mgr5f:hover, .css-4mgr5f:active, .css-4mgr5f:focus, .css-4mgr5f:visited, .css-4mgr5f:disabled, .css-4mgr5f[disabled] {\n    -webkit-align-items: baseline;\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    border-width: 0;\n    border-radius: 3px;\n    box-sizing: border-box;\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    font-family: inherit;\n    font-weight: 500;\n    max-width: 100%;\n    position: relative;\n    text-align: center;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    -webkit-transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n    transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n    white-space: nowrap;\n    background: var(--ds-background-brand-bold, #0052CC);\n    color: var(--ds-text-subtle, #344563);\n    cursor: pointer;\n    height: 2.2857142857142856em;\n    line-height: 2.2857142857142856em;\n    padding: 0 4px;\n    vertical-align: middle;\n    width: auto;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    outline: none;\n    background-color: transparent;\n    margin-left: 0;\n    margin-right: 0;\n}\n.css-178ag6o {\n    opacity: 1;\n    transition: opacity 0.3s ease 0s;\n    margin: 0px 2px;\n    -webkit-box-flex: 1;\n    flex-grow: 1;\n    flex-shrink: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.css-uiquy5 > * {\n    margin: 0px 4px;\n    flex-shrink: 0;\n}\n.css-1rowtot {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    margin-left: 0px;\n}\n.css-le7mka {\n    display: flex;\n    height: 100%;\n    position: relative;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    flex-direction: column;\n}\n.css-1ozpmrm {\n    width: 100%;\n    min-width: 1px;\n    margin: 0px;\n    position: relative;\n    flex-shrink: 1;\n}\n.css-d4blq8 {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    flex-shrink: 0;\n}\n.css-9wcsid {\n    position: relative;\n    width: 32px;\n    height: 32px;\n}\n@media screen and (min-width: 781px) {\n    .css-9wcsid {\n        min-width: 200px;\n    }    \n}\n.css-d4blq8 > * {\n    margin-right: 4px;\n    flex-shrink: 0;\n}\n.css-79elbk {\n    position: relative;\n}\n.css-44vo0a {\n    position: relative;\n    width: 780px;\n    box-shadow: var(--ds-shadow-overlay,0 4px 8px rgba(9,30,66,0.25),0 0 1px rgba(9,30,66,0.31));\n    border-radius: 3px;\n    background-color: var(--ds-surface-overlay,#fff);\n    overflow: hidden;\n    margin-top: 8px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n.css-9s05y4 {\n    display: block;\n    width: 8px;\n    height: 8px;\n    background-color: rgb(153, 141, 217);\n    position: absolute;\n    top: 0px;\n    left: 24px;\n    border-radius: 8px;\n    border: 3px solid white;\n}\n.css-1kr2iex {\n    height: 24px;\n    width: 24px;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n    background-color: var(--ds-surface-overlay, #FFFFFF);\n    border-radius: 50%;\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0px);\n    transition: transform 200ms ease 0s, opacity 200ms ease 0s;\n    box-shadow: 0 0 0 2px var(--ds-surface-overlay, #FFFFFF);\n    border: none;\n    margin: 2px;\n    padding: var(--ds-scale-0, 0px);\n    font-size: inherit;\n    font-family: inherit;\n}\n.css-13ep12v {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex: 1 1 100%;\n}\n.css-uiquy5 {\n    display: flex;\n    height: 100%;\n    position: relative;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n    flex: 1 0 0px;\n    -webkit-box-flex: 1;\n}\n.css-8u8t57 {\n    display: flex;\n    height: 100%;\n    position: relative;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    flex-direction: column;\n}\n.css-8u8t57::after {\n    height: 3px;\n    position: absolute;\n    right: 4px;\n    bottom: 0px;\n    left: 4px;\n    background-color: var(--button-selected-border-color);\n    border-top-left-radius: 1px;\n    border-top-right-radius: 1px;\n    content: \"\";\n}\n.css-pddbfj {\n    position: relative;\n    max-width: 100%;\n    width: 200px;\n}\n.css-pddbfj {\n    position: relative;\n    max-width: 100%;\n    width: 200px;\n}\n.css-wsgzdc {\n    display: none;\n}\n.css-54uz93, .css-54uz93:hover, .css-54uz93:active, .css-54uz93:focus, .css-54uz93:visited, .css-54uz93:disabled, .css-54uz93[disabled] {\n    -webkit-align-items: baseline;\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    border-width: 0;\n    border-radius: 100%;\n    box-sizing: border-box;\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-family: inherit;\n    font-weight: 500;\n    max-width: 100%;\n    position: relative;\n    text-align: center;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    -webkit-transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n    transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n    white-space: nowrap;\n    background: var(--ds-background-brand-bold, #0052CC);\n    color: var(--ds-text-subtlest, #6B778C);\n    cursor: pointer;\n    height: auto;\n    line-height: 2.2857142857142856em;\n    padding: 4px;\n    vertical-align: middle;\n    width: auto;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    outline: none;\n    margin: 0 2px;\n    background-color: var(--ds-background-input, #FFFFFF);\n    border-color: var(--ds-border-input, #DFE1E6);\n    icon-color: var(--ds-icon-subtle, #344563);\n}\n.css-1afrefi {\n    display: inline-block;\n    flex-shrink: 0;\n    line-height: 1;\n    width: 24px;\n    height: 24px;\n}\n.css-1afrefi > svg {\n    overflow: hidden;\n    pointer-events: none;\n    max-width: 100%;\n    max-height: 100%;\n    color: var(--icon-primary-color);\n    fill: var(--icon-secondary-color);\n    vertical-align: bottom;\n}\n.css-lvi2ji {\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    color: var(--ds-text-subtlest,#6B778C);\n}\n.css-lvi2ji > span[role=\"img\"] {\n    line-height: 0;\n}\n.css-1wits42 {\n    display: inline-block;\n    flex-shrink: 0;\n    line-height: 1;\n    width: 16px;\n    height: 16px;\n}\n.css-1wits42 > svg {\n    overflow: hidden;\n    pointer-events: none;\n    max-width: 100%;\n    max-height: 100%;\n    color: var(--icon-primary-color);\n    fill: var(--icon-secondary-color);\n    vertical-align: bottom;\n}\n.css-1n34ig8 {\n    height: 32px;\n    width: 100%;\n    padding: 0px 12px 0px 30px;\n    box-sizing: border-box;\n    outline: none;\n    border-radius: 5px;\n    font-size: 14px;\n    line-height: 20px;\n    border: 2px solid var(--ds-border-input,#DFE1E6);\n    box-shadow: none;\n    background-color: var(--ds-background-input,#FFFFFF);\n    color: var(--ds-text-subtlest,#6B778C);\n}\n@media (min-width: 1280px) {\n    .css-15lsza2 {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
